(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('TreatmentExperienceResponseDialogController', TreatmentExperienceResponseDialogController);

    TreatmentExperienceResponseDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TreatmentExperienceResponse'];

    function TreatmentExperienceResponseDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TreatmentExperienceResponse) {
        var vm = this;

        vm.treatmentExperienceResponse = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.treatmentExperienceResponse.id !== null) {
                TreatmentExperienceResponse.update(vm.treatmentExperienceResponse, onSaveSuccess, onSaveError);
            } else {
                TreatmentExperienceResponse.save(vm.treatmentExperienceResponse, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('getwellApp:treatmentExperienceResponseUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.date = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
